export enum ConsentManagementProvider {
  DIDOMI = 'didomi',
}
